import qs from 'qs';
import { axiosSingleton } from './generalApi';

export const fetchCmsPage = params => {
  // add query strings from URL as params in "/api/content" requests
  const queryObject = qs.parse(window.location.search.substring(1));

  return axiosSingleton
    .get(`/content`, { params: { ...params, ...queryObject } })
    .then(({ data }) => data)
    .catch(error => {
      throw error;
    });
};



// WEBPACK FOOTER //
// ./src/api/CmsPageApi.js